import http from "./http";
import { CREATED, OK } from "../utils/constant";

const VideoConfigService = {
  getByScreen:async(url)=>{
     try {
      const response = await http.GET(`page-tutorials/screen?route=${url}`);
      if (response.code === OK) {
        return response.data;
      }
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      // throw error;
    }
  },
  getVideoConfigList: async (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`page-tutorials?${queryString}`);
      console.log("list",response);
      
      if (response.code === 200 && response.data.data) {
        return response;
      }
      return null;
    } catch (error) {
      console.error("Error fetching page-tutorials", error);
      // throw error;
    }
  },
  //Save ICD
  saveVideoConfig: async (data) => {
    try {
      const response = await http.POST(`page-tutorials`, data);
      if (
        (response.code === OK || response.code === CREATED) &&
        response.data
      ) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error("Error fetching page-tutorials:", error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },

  //Delete ICD
  deleteVideoConfig: async (id) => {
    try {
      const response = await http.DELETE(`page-tutorials/${id}`);
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error("Error fetching page-tutorials:", error);
      throw error;
    }
  },
  getVideoConfigbyId: async (id) => {
    try {
      const response = await http.GET(`page-tutorials/${id}`);
      if (response.code === OK) {
        return response.data;
      }
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
  updateVideoConfigById: async (id, data) => {
    try {
      const response = await http.PUT(`page-tutorials/${id}`, data);
      if (response.code === OK) {
        return response.data;
      }
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
};

export default VideoConfigService;
